import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

/**
 * Fetches a fully-expanded schedule preview from the server.
 *
 * Unlike the client-side buildScheduleContent(), the server resolves
 * component-linked fields (componentRef / linkedFields) before expanding
 * macro tokens, so the preview correctly shows inherited values.
 *
 * @param {{ projectId: string, scheduleId: string }} params
 * @param {{ fetchPolicy?: import("@apollo/client").WatchQueryFetchPolicy | import("@apollo/client").FetchPolicy }} [options]
 * @returns {{ schedule: object, errors: Array }|null}
 */
export const getExpandedSchedulePreview = api(async function getExpandedSchedulePreview(
    { projectId, scheduleId },
    { fetchPolicy = "network-only" } = {}
) {
    if (!projectId || !scheduleId) return null
    return query(
        gql`
            query GetExpandedSchedulePreview($projectId: String!, $scheduleId: String!) {
                getExpandedSchedulePreview(projectId: $projectId, scheduleId: $scheduleId) {
                    schedule {
                        _id
                        id
                        version
                        code
                        title
                        unitOfMeasure
                        intro {
                            content
                            note
                        }
                        tasks {
                            id
                            isHeader
                            title
                            classification
                            content
                            note
                            taskId
                            headerTaskId
                            componentRef
                            linkedFields
                            frequency {
                                period
                                interval
                            }
                            skillSet
                            minutes
                            unitOfMeasure
                        }
                        legislation
                    }
                    errors {
                        type
                        tokens
                    }
                }
            }
        `,
        { projectId, scheduleId },
        {
            returns: "getExpandedSchedulePreview",
            fetchPolicy,
        }
    )
})
